<template>
  <panel class="epuap-result">
    <h3 v-if="!success">Nie udało się podpisać wniosku.</h3>

    <div v-else class="epuap-success">
      <h3>Wniosek został podpisany, ale nie jest jeszcze wysłany!</h3>
      
      <p>
        <strong>Uwaga!</strong>
        <br />
        W celu prawidłowego złożenia wniosku: 

        <ol>
          <li>kliknij <strong>„Powrót do dokumentu”</strong>,</li>

          <li>następnie na widoku <strong>„Szczegóły”</strong> wniosku kliknij przycisk <strong>„Wyślij przez ePUAP”</strong>,</li>

          <li>podpisany wniosek znajduje się w elektronicznej skrzynce nadawczej (wiadomości robocze), kliknij przycisk <strong>„Wyślij”</strong>,</li>

          <li>po kliknięciu przycisku <strong>„Wyślij”</strong>, w skrzynce ePUAP pojawi się komunikat potwierdzający złożenie wniosku.</li>
        </ol>
      </p>
    </div>

    <w-button class="btn-primary float-right" text="Powrót do dokumentu" @click="goToDocumentDetails" />
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { config } from '@/utils/config';

// @vuese
// Rezultat podpisania wniosku
// @group epuap
export default {
  components: { Panel },
  props: {
    success: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    resultMessage() {
      return this.success ? 'Wniosek został podpisany.' : 'Nie udało się podpisać wniosku.';
    }
  },
  methods: {
    // @vuese
    // Przechodzi do szczegółów dokumentu
    goToDocumentDetails() {
      this.$router.push({ name: 'documentDetails' });
    }
  }
};
</script>

<style>
.epuap-result {
  font-size: 18pt;
}
.epuap-result h3 {
  font-size: 22pt;
  font-weight: bold;
}
.epuap-result strong {
  font-weight: 700;
}
.epuap-result p {
  color: red;
}

.epuap-result ol {
  counter-reset: list;
}
.epuap-result ol > li {
  list-style: none;
}
.epuap-result ol > li:before {
  content: counter(list) ') ';
  counter-increment: list;
}
</style>